class ValidationForm extends HTMLElement {
  errorClass = 'text-red';
  validationMessages = {
    required: this.dataset.errorRequired,
    email: this.dataset.errorValidEmail,
  };
  constructor() {
    super();

    this.fieldsToValidate = this.querySelectorAll('[data-constraints]');
    let submitButton = this.querySelector('[submit]');
    if (submitButton) {
      submitButton.addEventListener('click', this.onSubmit.bind(this));
    }
  }
  onSubmit(event) {
    let focusOnError = false;

    this.fieldsToValidate.forEach((field) => {
      let constraints = field.dataset.constraints.split(' ');
      for (const constraint of constraints) {
        if (!!this.check[constraint]) {
          if (this.check[constraint](field)) {
            this.removeError(field);
          } else {
            if (!focusOnError) {
              focusOnError = field;
            }
            this.addError(constraint, field);
            event.preventDefault();
            break;
          }
        }
      }
    });

    if (focusOnError) {
      focusOnError.focus();
    }
  }

  check = {
    required(field) {
      return field.value.trim() !== '';
    },
    email(field) {
      const emailRegex = /^[^@\s]+@[^@\s]+.[^@\s]+$/;
      return emailRegex.test(field.value);
    },
  };

  addError(type, field) {
    this.removeError(field);
    field.setAttribute('invalid', 'true');
    field.setAttribute('aria-invalid', true);
    field.parentNode.setAttribute('validation-message', this.validationMessages[type]);
    const errorMessageId = `validation-error-${field.getAttribute('name').replace(/[\[|\]]/g, '')}-${type}`;
    field.parentNode.insertAdjacentHTML(
      'afterend',
      `<span id="${errorMessageId}" class="validation-error">${this.validationMessages[type]}</span>`,
    );
    field.setAttribute('aria-describedby', errorMessageId);
  }

  removeError(field) {
    field.removeAttribute('invalid');
    field.removeAttribute('aria-describedby');
    field.setAttribute('aria-invalid', false);
    field.parentElement.removeAttribute('validation-message');
    field.parentElement.querySelector(`.${this.errorClass}`)?.remove();
    field.parentElement.parentElement.querySelector('.validation-error')?.remove();
  }
}

customElements.define('validation-form', ValidationForm);
